<div class="p-10" *ngIf="selectionService.dataSource.data.length === 0 && !selectionService.isLoading">
    <p>No se encontraron registros</p>
</div>

<div class="p-10" *ngIf="selectionService.dataSource.data.length > 0 && !selectionService.isLoading">
    <div class="inner-card p-b-10 ">
        <div class="table-header-row">

            <mat-paginator [pageIndex]="selectionService.paginationProps.pageIndex"
                [length]="selectionService.paginationProps.length"
                [pageSize]="selectionService.paginationProps.pageSize" [pageSizeOptions]="[10, 50, 100]"
                (page)="getTasks($event)">
            </mat-paginator>

            <button mat-icon-button [matMenuTriggerFor]="tableColumnMenu" class="except table-toggle-button">
                <mat-icon class="except">table_chart</mat-icon>
            </button>

            <mat-menu #tableColumnMenu="matMenu" class="except">
                <div class="table-column-toggle-menu" (click)="$event.stopPropagation();">
                    <mat-checkbox *ngFor="let cd of displayedColumns | listFilter: 'ISPERMIT': true; let i = index"
                        (change)="toggleDisplayColumn(cd.column, $event.checked)" [checked]="cd.show"
                        [hidden]="cd.disabled">
                        {{cd.name}}</mat-checkbox>
                </div>
            </mat-menu>

        </div>
        <div class="list-tbl-view scroll-selection">
            <table mat-table matSort [dataSource]="selectionService.dataSource" class="mat-elevation-z8" #taskSelection
                id="selection-task">
                <caption></caption>

                <ng-container matColumnDef="action" class="except">
                    <th mat-header-cell *matHeaderCellDef id="actions"> </th>
                    <td mat-cell *matCellDef="let task" class="except">

                        <button aria-haspopup="true" class="navbar-toggle-button mat-icon-button icn-person except"
                            (click)="GoToEmployee(task.trabajadorId)">
                            <span class="mat-button-wrapper except">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    person </mat-icon>
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round except" matripple=""
                                ng-reflect-centered="true">
                            </div>
                            <div class="mat-button-focus-overlay except"></div>
                        </button>

                        <button mat-icon-button [matMenuTriggerFor]="appMenu" class="except">
                            <mat-icon class="except">more_vert</mat-icon>
                        </button>

                        <mat-menu #appMenu="matMenu" class="except">
                            <button class="except" mat-menu-item [matMenuTriggerFor]="print"
                                *ngIf="taskService.isPermitPrint && task.bloqueado == null">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    print </mat-icon> Imprimir
                            </button>
                            <button class="except" mat-menu-item (click)="changeTimePopup(task)"
                                *ngIf="taskService.isPermitChangeTime && task.bloqueado == null">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    access_time </mat-icon>Cambiar Hora
                            </button>
                            <button class="except" mat-menu-item (click)="deleteTask(task)"
                                *ngIf="taskService.isPermitDeleteTask && task.bloqueado == null">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    delete </mat-icon>Eliminar
                            </button>
                            <button class="except" mat-menu-item (click)="pedirCita(task.trabajadorId, task.bajaId)"
                            *ngIf="taskService.isPermitDeleteTask && task.tarea.includes('CITAR AL TRABAJADOR')">
                        <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                            date_range
                        </mat-icon>
                        Pedir cita
                    </button>
                        </mat-menu>

                        <mat-menu #print="matMenu" class="sub-menu except">
                            <button mat-menu-item (click)="PrintDocument(task)" class="except">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    print </mat-icon> Tarea Documento
                            </button>
                            <button mat-menu-item (click)="PrintCartaLopd(task)" class="except">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    print </mat-icon> Carta Lopd Documento
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <ng-container matColumnDef="marcas">
                    <th id="marcas" mat-header-cell *matHeaderCellDef> Marcas </th>
                    <td mat-cell *matCellDef="let task">
                        <span>
                            <span matTooltip="Marca de Empresa"
                                *ngIf="task.marcas !== null && task.marcas.includes('E')" class="lbl3">E</span>
                            <span matTooltip="Marca de Médico" *ngIf="task.marcas !== null && task.marcas.includes('M')"
                                class="lbl4">M</span>
                            <span matTooltip="Marca de Coordinador"
                                *ngIf="task.marcas !== null && task.marcas.includes('C')" class="lbl2">C</span>
                            <span matTooltip="Marca de Mutua" *ngIf="task.marcas !== null && task.marcas.includes('U')"
                                class="lbl8">U</span>
                            <span matTooltip="Marca de Diagnóstico"
                                *ngIf="task.marcas !== null && task.marcas.includes('D')" class="lbl7">D</span>
                            <span matTooltip="Marca de Zona" *ngIf="task.marcas !== null && task.marcas.includes('Z')"
                                class="lbl7">Z</span>
                            <span matTooltip="Marca externa" *ngIf="task.marcas !== null && task.marcas.includes('X')"
                                class="lbl7">X</span>
                            <span matTooltip="Marca de Simulación" *ngIf="task.marcas !== null && task.marcas.includes('S')"
                            class="lbl7">S</span>
                        </span>
                        <span *ngIf="selectionService.selectionPermissions.HasAbsentista">
                            <span matTooltip="Absentista" *ngIf="task.absentista === 'S'" class="lbl9">                            
                                <span class="fa fa-hand-stop-o icon-red"></span>                            
                            </span>
                        </span>
                        <span >
                            <span matTooltip="Prioritaria" *ngIf="task.prioritaria === 'S'" class="lbl9">
                                <span class="fa fa-star icon-red"></span>
                            </span>
                        </span>
                        <span >
                            <span matTooltip="Inspección" *ngIf="task.ifPresentacion !== null" class="lbl6">INSP</span>
                        </span>    
                    </td>                  
                </ng-container>

                <ng-container matColumnDef="empresa">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-company"> Empresa </th>
                    <td mat-cell *matCellDef="let task">
                        <div class="overflow-text">{{task.empresa | titlecase}}</div>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="proyecto">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-company"> Proyecto </th>
                    <td mat-cell *matCellDef="let task">
                        <div class="overflow-text">{{task.proyecto | titlecase}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="nivel1">
                    <th id="nivel1" mat-header-cell *matHeaderCellDef> Nivel 1 </th>
                    <td mat-cell *matCellDef="let task"> {{task.nivel1}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel2">
                    <th id="nivel2" mat-header-cell *matHeaderCellDef> Nivel 2 </th>
                    <td mat-cell *matCellDef="let task"> {{task.nivel2}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel3">
                    <th id="nivel3" mat-header-cell *matHeaderCellDef> Nivel 3 </th>
                    <td mat-cell *matCellDef="let task"> {{task.nivel3}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel4">
                    <th id="nivel4" mat-header-cell *matHeaderCellDef> Nivel 4 </th>
                    <td mat-cell *matCellDef="let task"> {{task.nivel4}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel5">
                    <th id="nivel5" mat-header-cell *matHeaderCellDef> Nivel 5 </th>
                    <td mat-cell *matCellDef="let task"> {{task.nivel5}} </td>
                </ng-container>
                <ng-container matColumnDef="enif">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-company"> NIF </th>
                    <td mat-cell *matCellDef="let task">
                        <div class="overflow-text">{{task.enif | titlecase}}</div>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="referencia">
                    <th id="referencia" mat-header-cell *matHeaderCellDef> Ref. Trabajador </th>
                    <td mat-cell *matCellDef="let task"> {{task.referencia | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="leaveRef">
                    <th id="leaveRef" mat-header-cell *matHeaderCellDef> Referencia de Baja </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.leaveRef}} </td>
                </ng-container>

                <ng-container matColumnDef="trabajador">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-employee">Trabajador </th>
                    <td mat-cell *matCellDef="let task"> {{task.trabajador | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="fFinContrato">
                    <th id="fFinContrato" mat-header-cell *matHeaderCellDef> F. Fin Contrato </th>
                    <td mat-cell *matCellDef="let task"> {{task.fFinContrato | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="prioritaria">
                    <th id="prioritaria" mat-header-cell *matHeaderCellDef> Prior. </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.prioritaria === 'S'">
                            <mat-icon><span class="fa fa-star icon-yellow"></span></mat-icon>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="tipoB">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-date"> Tipo B. </th>
                    <td mat-cell *matCellDef="let task"> {{task.tipo}} </td>
                </ng-container>

                <ng-container matColumnDef="fBaja">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-date"> F. Baja </th>
                    <td mat-cell *matCellDef="let task"> {{task.fBaja|date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="nomMedico">
                    <th id="nomMedico" mat-header-cell *matHeaderCellDef> Médico </th>
                    <td mat-cell *matCellDef="let task"> {{task.nomMedico}} </td>
                </ng-container>

                <ng-container matColumnDef="nj">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-date"> NJ </th>
                    <td mat-cell *matCellDef="let task">
                        <span *ngIf="task.justificada === 'N'" class="lbl1">NJ</span>
                        <span *ngIf="task.justificada === 'A'" class="lbl8">JA</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaNj">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-time"> Fecha NJ </th>
                    <td mat-cell *matCellDef="let task"> {{task.fechaNJ|date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="diasNj">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-time"> Días NJ </th>
                    <td mat-cell *matCellDef="let task"> {{task.diasNj}} </td>
                </ng-container>

                <ng-container matColumnDef="fpa">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-time"> FPA </th>
                    <td mat-cell *matCellDef="let task"> {{task.fpa|date:"dd/MM/yyyy"}} </td>
                </ng-container>
                <ng-container matColumnDef="diasPrevistos">
                    <th id="diasPrevistos" mat-header-cell *matHeaderCellDef> Días previstos </th>
                    <td mat-cell *matCellDef="let task"> {{task.diasPrevistos}} </td>
                </ng-container>

                <ng-container matColumnDef="diagnostico">
                    <th id="diagnostico" mat-header-cell *matHeaderCellDef> Diagnóstico </th>
                    <td mat-cell *matCellDef="let task"> {{task.diagnostico | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="phones">
                    <th id="phones" mat-header-cell *matHeaderCellDef> Teléfonos </th>
                    <td mat-cell *matCellDef="let task"> {{task.phones}} </td>
                </ng-container>
                <ng-container matColumnDef="direccion">
                    <th id="direccion" mat-header-cell *matHeaderCellDef> Dirección </th>
                    <td mat-cell *matCellDef="let task"> {{task.direccion}} </td>
                </ng-container>
                <ng-container matColumnDef="poblacion">
                    <th id="poblacion" mat-header-cell *matHeaderCellDef> Población </th>
                    <td mat-cell *matCellDef="let task"> {{task.poblacion}} </td>
                </ng-container>
                <ng-container matColumnDef="cp">
                    <th id="cp" mat-header-cell *matHeaderCellDef> CP </th>
                    <td mat-cell *matCellDef="let task"> {{task.cp}} </td>
                </ng-container>
                <ng-container matColumnDef="provincia">
                    <th id="provincia" mat-header-cell *matHeaderCellDef> Provincia </th>
                    <td mat-cell *matCellDef="let task"> {{task.provincia}} </td>
                </ng-container>
                <ng-container matColumnDef="consentimiento">
                    <th id="consentimiento" mat-header-cell *matHeaderCellDef> Consentimiento </th>
                    <td mat-cell *matCellDef="let task"> {{checkConsentimento(task.tipoConsentimiento,task.consentimiento)}} </td>
                </ng-container>
                <ng-container matColumnDef="fConsentimiento">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-time"> F.Consentimiento </th>
                    <td mat-cell *matCellDef="let task"> {{task.fConsentimiento|date:"dd/MM/yyyy"}} </td>
                </ng-container>


                <ng-container matColumnDef="atributos">
                    <th id="atributos" mat-header-cell *matHeaderCellDef> Atributos </th>
                    <td mat-cell *matCellDef="let leave">
                        <span *ngIf="leave.tAttr1 != null && leave.tAttr1 != ''"> {{leave.tAttr1 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr2 != null && leave.tAttr2 != ''"> {{leave.tAttr2 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr3 != null && leave.tAttr3 != ''"> {{leave.tAttr3 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr4 != null && leave.tAttr4 != ''"> {{leave.tAttr4 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr5 != null && leave.tAttr5 != ''"> {{leave.tAttr5 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr6 != null && leave.tAttr6 != ''"> {{leave.tAttr6 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr7 != null && leave.tAttr7 != ''"> {{leave.tAttr7 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr8 != null && leave.tAttr8 != ''"> {{leave.tAttr8 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr9 != null && leave.tAttr9 != ''"> {{leave.tAttr9 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr10 != null && leave.tAttr10 != ''"> {{leave.tAttr10 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr11 != null && leave.tAttr11 != ''"> {{leave.tAttr11 | titlecase}} ||</span>
                        <span *ngIf="leave.tAttr12 != null && leave.tAttr12 != ''"> {{leave.tAttr12 | titlecase}} ||</span>
                        <span *ngIf="(leave.tAttr1 === null || leave.tAttr1 === '') && 
              (leave.tAttr2 === null || leave.tAttr2 === '') && 
              (leave.tAttr3 === null || leave.tAttr3 === '') &&
              (leave.tAttr4 === null || leave.tAttr4 === '') &&
              (leave.tAttr5 === null || leave.tAttr5 === '') &&
              (leave.tAttr6 === null || leave.tAttr6 === '') &&
              (leave.tAttr7 === null || leave.tAttr7 === '') &&
              (leave.tAttr8 === null || leave.tAttr8 === '') &&
              (leave.tAttr9 === null || leave.tAttr9 === '') &&
              (leave.tAttr10 === null || leave.tAttr10 === '') &&
              (leave.tAttr11 === null || leave.tAttr11 === '') &&
              (leave.tAttr12 === null || leave.tAttr12 === '')">
                            Sin Atributos
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="tAttr1">
                    <th id="tAttr1" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[0].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr1 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr2">
                    <th id="tAttr2" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[1].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr2 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr3">
                    <th id="tAttr3" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[2].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr3 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr4">
                    <th id="tAttr4" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[3].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr4 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr5">
                    <th id="tAttr5" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[4].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr5 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr6">
                    <th id="tAttr6" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[5].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr6 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr7">
                    <th id="tAttr7" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[6].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr7 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr8">
                    <th id="tAttr8" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[7].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr8 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr9">
                    <th id="tAttr9" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[8].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr9 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr10">
                    <th id="tAttr10" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[9].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr10 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr11">
                    <th id="tAttr11" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[10].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr11 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr12">
                    <th id="tAttr12" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[11].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr12 | titlecase}} </td>
                </ng-container>


                <ng-container matColumnDef="fecha">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-time"> Fecha </th>
                    <td mat-cell *matCellDef="let task"> {{task.fecha|date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="hora">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-time"> Hora </th>
                    <td mat-cell *matCellDef="let task"> {{task.hora|date:"HH:mm"}} </td>
                </ng-container>

                <ng-container matColumnDef="tarea">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-task"> Tarea </th>
                    <td mat-cell *matCellDef="let task">
                        <div> {{task.tarea}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="autor">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-task"> Autor </th>
                    <td mat-cell *matCellDef="let task">
                        <div class="overflow-text">{{task.autor | titlecase}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="comentario">
                    <th mat-header-cell *matHeaderCellDef id="task-selection-task"> Comentario </th>
                    <td mat-cell *matCellDef="let task">
                        <span *ngIf="task.comentario">{{task.comentario.substr(0, 250)}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fRegistro">
                    <th id="fRegistro" mat-header-cell *matHeaderCellDef> F. Registro </th>
                    <td mat-cell *matCellDef="let task"> {{task.fRegistro | date:"dd/MM/yyyy hh:mm" }} </td>
                </ng-container>

                <ng-container matColumnDef="usuario">
                    <th id="usuario" mat-header-cell *matHeaderCellDef> Usuario </th>
                    <td mat-cell *matCellDef="let task"> {{task.usuario}} </td>
                </ng-container>

                <ng-container matColumnDef="fEnvio">
                    <th id="fEnvio" mat-header-cell *matHeaderCellDef>F. Envío </th>
                    <td mat-cell *matCellDef="let task"> {{task.fEnvio | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="realizada">
                    <th id="realizada" mat-header-cell *matHeaderCellDef>Realizada </th>
                    <td mat-cell *matCellDef="let task"> {{task.realizada | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="fReclamacion">
                    <th id="fReclamacion" mat-header-cell *matHeaderCellDef>F. Últ. Reclamación </th>
                    <td mat-cell *matCellDef="let task"> {{task.fReclamacion | date:"dd/MM/yyyy"}} </td>
                </ng-container>
                <ng-container matColumnDef="reclTelefonica">
                    <th id="reclTelefonica" mat-header-cell *matHeaderCellDef>Nº Tels </th>
                    <td mat-cell *matCellDef="let task"> {{task.reclTelefonica}} </td>
                </ng-container>

                <ng-container matColumnDef="reclUSuario">
                    <th id="reclUSuario" mat-header-cell *matHeaderCellDef>Nº Emails </th>
                    <td mat-cell *matCellDef="let task"> {{task.reclUSuario}} </td>
                </ng-container>

                <ng-container matColumnDef="reclObs">
                    <th id="reclObs" mat-header-cell *matHeaderCellDef>Observaciones </th>
                    <td mat-cell *matCellDef="let task"> {{task.reclObs}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
                <tr mat-row *matRowDef="let task; columns: getDisplayedColumns();"
                    [ngClass]="{'selection-highlight-row': selectedRowIndex == task.tareaId && selectionService.isShowLeavePanel}"
                    (click)="getLeaveRecord(task, $event)">
                </tr>
            </table>
        </div>
    </div>
</div>